"use client";

import { useEffect } from "react";

import { useMarket } from "#/store/app/portfolio/market";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";

export const MobileUpdater: React.FC = () => {
  const { market } = useMarket();
  const { setMarket } = usePositionsDrawerMarket();

  // Sync the market store to the positions drawer store only in mobile, if there is a re-used component between desktop and mobile, the market store should be used as a source of truth for the market, and the positions drawer market should be updated to reflect the current market in mobile
  useEffect(() => {
    setMarket(market);
  }, [market, setMarket]);

  return null;
};
